var _path, _rect, _path2, _path3, _circle, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _circle2, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdsPlot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b5ba9921-0f86-40ea-931c-c7d258b36081",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 810.896,
    height: 522.41899,
    viewBox: "0 0 810.896 522.41899",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "b2e49937-4c28-4650-9a4e-f6eb0342852c",
    "data-name": "Path 902",
    d: "M862.489,219.40751s-12.428-4.438-20.417,13.315-20.417,37.283-20.417,37.283l7.1,1.775s1.775-12.428,6.214-14.2l-1.774,15.977s53.261,18.641,77.228-1.775l-.888-6.214s3.554.889,3.554,6.213l2.663-2.663s-2.663-5.326-10.652-12.428c-5.244-4.661-7.046-13.529-7.665-19.073a23.08084,23.08084,0,0,0-5.314-12.569C886.81,218.89551,877.136,212.35749,862.489,219.40751Z",
    transform: "translate(-194.552 -188.7905)",
    fill: "#2f2e41"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "b235f806-e2c9-45ef-b703-f7f371930907",
    "data-name": "Rectangle 111",
    x: 267,
    y: 225.059,
    width: 434.83701,
    height: 293.36099,
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "e6118afa-4c53-4ea0-93af-402108239327",
    "data-name": "Path 709",
    d: "M897.47,709.20954H459.634v-296.36H897.47Zm-434.837-3H894.471v-290.361H462.633Z",
    transform: "translate(-194.552 -188.7905)",
    fill: "#3f3d56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "b8219341-780b-4b9f-9d82-e7d3fa088cf7",
    "data-name": "Path 710",
    d: "M498.552,682.7265H859.895v-244.877H498.552Z",
    transform: "translate(-194.552 -188.7905)",
    fill: "#e5e5e5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "b57d6a17-8879-4c63-8b1e-809c4937ad7c",
    "data-name": "Group 55"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "f626c2c6-7cdb-4d92-a189-e8377e4d5dd9",
    "data-name": "Ellipse 110",
    cx: 406.64301,
    cy: 377.057,
    r: 37.928,
    fill: "#3f3d56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "aef23fce-a5bc-48f3-9270-c0a812cf70d7",
    "data-name": "Path 711",
    d: "M720.131,682.73053H534.07a3.79889,3.79889,0,0,1-.7-.055l88-152.425a6.161,6.161,0,0,1,10.725,0l59.06207,102.28,2.829,4.895Z",
    transform: "translate(-194.552 -188.7905)",
    fill: "#ceb78b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "f49f870d-1e60-4ae8-9c2e-844cb844297a",
    "data-name": "Path 712",
    d: "M720.132,682.72651H656.605l31.185-45.3,2.246-3.263,1.123-1.632,2.828,4.895Z",
    transform: "translate(-194.552 -188.7905)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "f26d8b81-72d3-442f-931c-1cf77feee227",
    "data-name": "Path 713",
    d: "M823.729,682.72648H662.801l31.185-45.3,2.244-3.263,40.636-59.03a8.22292,8.22292,0,0,1,12.206-.73,7.34064,7.34064,0,0,1,.585.73Z",
    transform: "translate(-194.552 -188.7905)",
    fill: "#ceb78b"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "af23e7e7-c6d9-490d-9a1e-f56b632e5413",
    "data-name": "Path 916",
    d: "M902.931,419.22851a10.743,10.743,0,0,0-3.807-16.027l-27.553-93.885-20.981,10.275,33.681,89.055a10.8,10.8,0,0,0,18.66,10.581Z",
    transform: "translate(-194.552 -188.7905)",
    fill: "#a0616a"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "edb8a645-d37c-41d5-9dcf-4e84f2320980",
    "data-name": "Path 917",
    d: "M877.813,324.9955l-23.483,6.357a4.81706,4.81706,0,0,1-6.042-4.086l-2.838-24.087a13.37753,13.37753,0,0,1,25.846-6.915l9.674,22.156a4.81711,4.81711,0,0,1-3.156,6.576Z",
    transform: "translate(-194.552 -188.7905)",
    fill: "#ceb78b"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "faf5a66f-1aba-46ba-93f5-cb656330ef2a",
    "data-name": "Path 918",
    d: "M909.068,508.62451h12.26l5.833-31.8h-18.1Z",
    transform: "translate(-194.552 -188.7905)",
    fill: "#a0616a"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "be6067fd-5756-458a-b264-3124d9ac4730",
    "data-name": "Path 919",
    d: "M905.941,504.62249H930.09a15.386,15.386,0,0,1,15.387,15.385v.502H905.942Z",
    transform: "translate(-194.552 -188.7905)",
    fill: "#2f2e41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "bc15289d-c7cc-497e-9eba-f743ca86984b",
    "data-name": "Path 920",
    d: "M923.299,491.57451q-.214,0-.43-.021l-16.967-1.235a4.5,4.5,0,0,1-3.809-6.029l22.707-51.015a3.5,3.5,0,0,0-.2-2.8,3.45016,3.45016,0,0,0-2.211-1.76c-10.677-2.791-38.072-10.223-61.786-18.918-10.16-3.726-16.559-9.109-19.019-16-3.243-9.087,1.555-17.374,1.76-17.722l.161-.272,22.315,2.028,24.191,2.058,53.013,28.428a20.086,20.086,0,0,1,8.819,25.784l-24.441,54.808A4.5,4.5,0,0,1,923.299,491.57451Z",
    transform: "translate(-194.552 -188.7905)",
    fill: "#2f2e41"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "a3671197-e5f2-4548-b9a0-ff23f71bc6d2",
    "data-name": "Ellipse 175",
    cx: 675.14999,
    cy: 63.55,
    r: 24.561,
    fill: "#a0616a"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "a9d8beb4-4f13-47fd-a447-3d490f855901",
    "data-name": "Path 921",
    d: "M902.068,507.62451h12.26l5.833-31.8h-18.1Z",
    transform: "translate(-194.552 -188.7905)",
    fill: "#a0616a"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "e16f5ea7-6bcf-4ae4-aafd-84926ba11e55",
    "data-name": "Path 922",
    d: "M898.941,503.62249H923.09a15.386,15.386,0,0,1,15.387,15.385v.502H898.942Z",
    transform: "translate(-194.552 -188.7905)",
    fill: "#2f2e41"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "aac7d351-7374-43cc-a3f5-61c2d0096742",
    "data-name": "Path 923",
    d: "M916.299,494.57451q-.214,0-.43-.021l-16.967-1.235a4.5,4.5,0,0,1-3.809-6.029l22.707-51.015a3.5,3.5,0,0,0-.2-2.8,3.45107,3.45107,0,0,0-2.211-1.76c-10.677-2.791-38.072-10.223-61.786-18.918-10.16-3.726-16.559-9.109-19.019-16-3.243-9.087,1.555-17.374,1.76-17.722l.161-.272,22.315,2.028,24.191,2.058,53.013,28.428a20.086,20.086,0,0,1,8.819,25.784l-24.441,54.808A4.5,4.5,0,0,1,916.299,494.57451Z",
    transform: "translate(-194.552 -188.7905)",
    fill: "#2f2e41"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "f2896a95-4921-48fa-961d-daef5cb77ff3",
    "data-name": "Path 924",
    d: "M877.277,290.82851l-26-9s-16.322,12.54-8.481,43.649a77.01216,77.01216,0,0,1-3.4,48.32,49.78149,49.78149,0,0,1-2.619,5.531s29,35,56,9l-10.5-50.5S898.777,304.32851,877.277,290.82851Z",
    transform: "translate(-194.552 -188.7905)",
    fill: "#cbcbcb"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "e5957349-8d61-4100-bbc5-9120baddf6f7",
    "data-name": "Path 930",
    d: "M940.344,414.72851a10.74306,10.74306,0,0,0-7.691-14.567l-50.135-84.024-17.748,15.192,54.862,77.816a10.8,10.8,0,0,0,20.712,5.584Z",
    transform: "translate(-194.552 -188.7905)",
    fill: "#a0616a"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "a823d3eb-16ed-485f-b649-95b37def4678",
    "data-name": "Path 931",
    d: "M892.48,329.76052l-21.15,12.022a4.817,4.817,0,0,1-6.871-2.446l-8.769-22.616a13.37807,13.37807,0,0,1,23.3-13.153h0l14.9,19.037a4.81706,4.81706,0,0,1-1.413,7.156Z",
    transform: "translate(-194.552 -188.7905)",
    fill: "#cbcbcb"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "ba9c4ab1-3c32-43b1-9e29-14ec75141c77",
    "data-name": "Path 912",
    d: "M841.70079,256.94488S852.75,244.08149,858.965,242.30649a53.461,53.461,0,0,0,10.73579-4.36161s12.34221,11.4636,22.10716,12.3506.888-21.3.888-21.3l-17.754-4.438-16.866,1.775-13.315,8.877Z",
    transform: "translate(-194.552 -188.7905)",
    fill: "#2f2e41"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "b141057d-eb11-43c4-9f65-4e91bf80c4d1",
    "data-name": "Path 940",
    d: "M194.552,415.33651c0-67.165,54.448-226.546,121.614-226.546s121.614,159.381,121.614,226.546a121.614,121.614,0,0,1-243.227,0Z",
    transform: "translate(-194.552 -188.7905)",
    fill: "#e5e5e5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "bbc7cc74-7f66-47db-a1e0-6b895922b5e5",
    "data-name": "Path 941",
    d: "M316.166,711.2095a1,1,0,0,1-1-1v-419.284a1,1,0,0,1,2,0v419.284A1,1,0,0,1,316.166,711.2095Z",
    transform: "translate(-194.552 -188.7905)",
    fill: "#ccc"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "aa090f12-fc72-4747-96ed-1e637a9aabc0",
    "data-name": "Path 942",
    d: "M316.166,371.87051a1,1,0,0,1-.707-.293l-48.135-48.134a1,1,0,0,1,1.414-1.414l48.135,48.134a1,1,0,0,1-.707,1.707Z",
    transform: "translate(-194.552 -188.7905)",
    fill: "#ccc"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "f06f9ddb-9983-4bae-8569-c526944405df",
    "data-name": "Path 943",
    d: "M316.166,455.20049a1,1,0,0,1-.707-1.707l80.61-80.61a1,1,0,1,1,1.43851,1.38949l-.02451.02451-80.61,80.612a1,1,0,0,1-.707.293Z",
    transform: "translate(-194.552 -188.7905)",
    fill: "#ccc"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "b7aca4fe-24cd-43d3-85a6-0827311119f8",
    "data-name": "Path 944",
    d: "M1004.448,711.20851h-743a1,1,0,0,1,0-2h743a1,1,0,0,1,0,2Z",
    transform: "translate(-194.552 -188.7905)",
    fill: "#e6e6e6"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "e899ea61-7254-4511-8cd4-eee51d306eb6",
    "data-name": "Path 932",
    d: "M350.427,634.42051c0-17.206,13.957-58.034,31.174-58.034s31.175,40.825,31.175,58.034a31.1745,31.1745,0,0,1-62.349,0Z",
    transform: "translate(-194.552 -188.7905)",
    fill: "#ceb78b"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "fa335772-b1dd-4709-9797-f8733d8b63ac",
    "data-name": "Path 933",
    d: "M381.601,710.20852a.256.256,0,0,1-.256-.256V602.54549a.2565.2565,0,1,1,.513,0v107.407a.256.256,0,0,1-.256.256Z",
    transform: "translate(-194.552 -188.7905)",
    fill: "#e6e6e6"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "a36a4113-4cfd-4bd3-b691-45e56c5648f2",
    "data-name": "Path 934",
    d: "M381.601,623.28052a.2551.2551,0,0,1-.181-.075l-12.339-12.33a.25633.25633,0,0,1,.363-.362h0l12.339,12.33a.256.256,0,0,1-.181.437Z",
    transform: "translate(-194.552 -188.7905)",
    fill: "#e6e6e6"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "f51cff30-dd4b-4c92-a862-4e920cec8d6d",
    "data-name": "Path 935",
    d: "M381.601,644.62849a.256.256,0,0,1-.181-.437l20.664-20.65a.25632.25632,0,0,1,.363.362l-20.665,20.65A.255.255,0,0,1,381.601,644.62849Z",
    transform: "translate(-194.552 -188.7905)",
    fill: "#e6e6e6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdsPlot);
export default __webpack_public_path__ + "static/media/ads_plot.5d535cfe.svg";
export { ForwardRef as ReactComponent };